import React from 'react';
import {useTranslation} from 'react-i18next';
import {IPresentationTheme} from '../../../../../incase-domain/presentationTheme';
import SelectQuestionElementFontSize from './SelectQuestionElementFontSize';

interface PresentationThemeQuestionElementProps {
    presentationTheme: IPresentationTheme;
    setPresentationTheme: React.Dispatch<React.SetStateAction<IPresentationTheme>>;
}

export default function PresentationThemeQuestionElement(props: PresentationThemeQuestionElementProps): JSX.Element {
    const {presentationTheme, setPresentationTheme} = props;
    const {t} = useTranslation();

    const questionTheme = presentationTheme.elementStyles?.questionElement;

    const updatePresentationTheme = <T extends keyof NonNullable<Required<IPresentationTheme>['elementStyles']['questionElement']>>(
        key: T,
        value: NonNullable<Required<IPresentationTheme>['elementStyles']['questionElement']>[T]
    ): void => {
        setPresentationTheme((prevTheme) => ({
            ...prevTheme,
            elementStyles: {
                ...prevTheme.elementStyles,
                questionElement: {
                    ...prevTheme.elementStyles?.questionElement,
                    [key]: value,
                },
            },
        }));
    };

    return (
        <>
            <div className="u-pb-2">
                <strong>{t('presentationThemesPage.question.questionElement')}</strong>
            </div>
            <SelectQuestionElementFontSize
                title={t('presentationThemesPage.question.questionFontSize')}
                placeholder={t('presentationThemesPage.question.select')}
                elementFontSize={questionTheme?.questionFontSize}
                setElementFontSize={(newValue) => newValue && updatePresentationTheme('questionFontSize', newValue)}
                presentationTheme={presentationTheme}
            />
            <SelectQuestionElementFontSize
                title={t('presentationThemesPage.question.answerFontSize')}
                placeholder={t('presentationThemesPage.question.select')}
                elementFontSize={questionTheme?.answerFontSize}
                setElementFontSize={(newValue) => newValue && updatePresentationTheme('answerFontSize', newValue)}
                presentationTheme={presentationTheme}
            />
            <SelectQuestionElementFontSize
                title={t('presentationThemesPage.question.commentFontSize')}
                placeholder={t('presentationThemesPage.question.select')}
                elementFontSize={questionTheme?.commentFontSize}
                setElementFontSize={(newValue) => newValue && updatePresentationTheme('commentFontSize', newValue)}
                presentationTheme={presentationTheme}
            />
        </>
    );
}
